import React, { useState } from 'react';
import api from '../services/api';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await api.post('/auth/send-link', { email });
      setSent(true);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={styles.icon}>📧</div>
          <h2 style={styles.title}>Check your email</h2>
          <p style={styles.subtitle}>
            We sent a login link to <strong>{email}</strong>.<br />
            Click the link in the email to log in.
          </p>
          <p style={styles.note}>The link expires in 15 minutes.</p>
          <button style={styles.linkBtn} onClick={() => setSent(false)}>
            Use a different email
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.icon}>🛒</div>
        <h1 style={styles.title}>Supermarket Price Comparison</h1>
        <p style={styles.subtitle}>Cyprus</p>
        <form onSubmit={handleSubmit} style={styles.form}>
          <label style={styles.label}>Enter your email to log in</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            required
            style={styles.input}
          />
          {error && <p style={styles.error}>{error}</p>}
          <button type="submit" disabled={loading} style={styles.button}>
            {loading ? 'Sending...' : 'Send Login Link'}
          </button>
        </form>
        <p style={styles.note}>No password needed. We'll email you a magic link.</p>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#F0F4F8',
    padding: 16,
  },
  card: {
    background: 'white',
    borderRadius: 12,
    padding: '48px 40px',
    maxWidth: 420,
    width: '100%',
    textAlign: 'center',
    boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
  },
  icon: { fontSize: 48, marginBottom: 12 },
  title: { color: '#2952CC', fontSize: 24, fontWeight: 700, margin: '0 0 8px' },
  subtitle: { color: '#5D6D7E', fontSize: 15, margin: '0 0 28px' },
  form: { display: 'flex', flexDirection: 'column', gap: 12 },
  label: { textAlign: 'left', fontSize: 14, fontWeight: 600, color: '#2952CC' },
  input: {
    padding: '12px 14px', borderRadius: 8, border: '1.5px solid #C5D5FF',
    fontSize: 15, outline: 'none',
  },
  button: {
    padding: '13px', background: '#2952CC', color: 'white',
    border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600,
    cursor: 'pointer', marginTop: 4,
  },
  error: { color: '#E74C3C', fontSize: 13, margin: 0 },
  note: { color: '#999', fontSize: 13, marginTop: 20 },
  linkBtn: {
    background: 'none', border: 'none', color: '#2952CC',
    cursor: 'pointer', fontSize: 14, textDecoration: 'underline', marginTop: 8,
  },
};

export default LoginPage;
